import { ScoreWithFixAndNoFix } from '@internal/ui-common';
import { VulnerabilityItem } from '@internal/schemas-common';
import { scoreRules } from './scoreRules';

const calculateScore = (
  vulnerabilities: VulnerabilityItem[],
): ScoreWithFixAndNoFix => {
  const counts = {
    red: { fix: 0, noFix: 0 },
    orange: { fix: 0, noFix: 0 },
  };

  const grouped = new Map<string, Map<string, VulnerabilityItem[]>>();

  vulnerabilities.forEach(vulnerability => {
    const { project, source } = vulnerability;

    if (!grouped.has(project)) {
      grouped.set(project, new Map<string, VulnerabilityItem[]>());
    }

    const projectGroup = grouped.get(project)!;

    if (!projectGroup.has(source)) {
      projectGroup.set(source, []);
    }

    projectGroup.get(source)!.push(vulnerability);
  });

  grouped.forEach(sourceMap => {
    sourceMap.forEach(vulnerabilityList => {
      const seenIds = new Set<string>();

      vulnerabilityList.forEach(vulnerability => {
        const { id, severity, fixedVersion } = vulnerability;

        if (seenIds.has(id)) {
          return;
        }
        seenIds.add(id);

        if (scoreRules.red.rule(severity)) {
          if (fixedVersion === 'Not Yet Fixed') {
            counts.red.noFix++;
          } else {
            counts.red.fix++;
          }
        } else if (scoreRules.orange.rule(severity)) {
          if (fixedVersion === 'Not Yet Fixed') {
            counts.orange.noFix++;
          } else {
            counts.orange.fix++;
          }
        }
      });
    });
  });

  return counts;
};

export const getVulnerabilityScore = (
  vulnerabilities: VulnerabilityItem[] | undefined,
): ScoreWithFixAndNoFix => {
  if (vulnerabilities?.length) {
    const score = calculateScore(vulnerabilities);
    return score;
  }
  return {
    red: { fix: 0, noFix: 0 },
    orange: { fix: 0, noFix: 0 },
  };
};
